import styled from 'styled-components'

import CMYK from 'shared/entities/CMYK'
import {
  ColorCMYK,
  StyledComponentWithCompound
} from 'shared/types/global'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 4px;
`

export const Title = styled.div`
  font-size: 12px;
  color: ${({ theme }) => theme.color.base.c6};
`

export const Image: StyledComponentWithCompound = styled.div<{
  backgroundUrl: string | null
}>`
  width: 72px;
  height: 98px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 5px;
  background-color: ${({ theme }) => theme.color.base.c2};
  background-image: ${({ backgroundUrl }) =>
    backgroundUrl ? `url(${backgroundUrl})` : 'none'};
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
`

Image.Refresh = styled.div`
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background-color: ${({ theme }) => theme.color.base.c2};
  box-shadow: 0px 0.73px 1.45px 0px #2125291a,
    0px 0.73px 1.45px 1.09px #ffffff4d inset,
    0px -1.45px 1.45px 0.36px #0000001a inset;
  cursor: pointer;
`

export const Color: StyledComponentWithCompound = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  cursor: pointer;
`

Color.Circle = styled.div<{
  color: ColorCMYK
}>`
  width: 16px;
  height: 16px;
  border-radius: 50%;
  border: 1px solid ${({ theme }) => theme.color.base.c3};
  background-color: ${({ color, theme }) =>
    color ? new CMYK(color).toCSS() : theme.color.base.c2};
`

Color.Title = styled.span`
  font-size: 12px;
  font-weight: 600;
  color: ${({ theme }) => theme.color.base.c7};
`
